import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { translationPropType } from '@eb/i18n';

import { Icon } from '@eb/eds-icon';
import { ICON_TYPE_PROP_TYPE } from '@eb/eds-icon';

import { LogoWordmarkBrand } from '@eb/eds-iconography';

import './PageHeader.scss';

const HeaderIcon = ({ iconType, iconColor, iconSize }) => {
    const classes = classNames(
        'eds-l-mar-bot-6',
        'eds-fx--pop eds-fx--delay-1',
        'eds-bg-color--white',
        'authentication__page-header__icon',
    );

    return (
        <div className={classes} data-spec="page-header-icon">
            <Icon size={iconSize} type={iconType} color={iconColor} />
        </div>
    );
};

const HeaderTitle = ({ headerText, usesNewStyles }) => {
    const headerClasses = usesNewStyles
        ? 'eds-text-hl'
        : 'eds-text-hm eds-l-mar-bot-10';

    return (
        <h1 className={headerClasses} data-spec="page-header-title">
            {headerText}
        </h1>
    );
};

const HeaderSubTitle = ({ subtitleText, usesNewStyles }) => {
    let component = null;

    if (subtitleText) {
        const headerSubTitleClasses = classNames(
            'eds-text-color--grey-600',
            'eds-text-bm',
            {
                'eds-l-mar-bot-8 eds-l-mar-hor-3': !usesNewStyles,
                'eds-l-pad-top-2': usesNewStyles,
            },
        );

        component = (
            <div
                className={headerSubTitleClasses}
                data-spec="page-header-subtitle"
            >
                {subtitleText}
            </div>
        );
    }

    return component;
};

export default class PageHeader extends React.PureComponent {
    static propTypes = {
        headerText: translationPropType.isRequired,
        iconType: ICON_TYPE_PROP_TYPE,
        subtitleText: translationPropType,
        iconColor: PropTypes.string,
        picture: PropTypes.string,
    };

    static defaultProps = {
        iconColor: 'ui-orange',
        iconSize: 'medium',
    };

    render() {
        const {
            headerText,
            subtitleText,
            iconColor,
            iconSize,
            picture,
            usesNewStyles,
        } = this.props;
        let { iconType } = this.props;
        let icon = null;

        if (usesNewStyles && !iconType) {
            iconType = <LogoWordmarkBrand />;
        }

        if (iconType) {
            icon = (
                <HeaderIcon
                    iconType={iconType}
                    iconColor={iconColor}
                    iconSize={iconSize}
                />
            );
        }

        if (picture) {
            icon = (
                <img
                    className="authentication__page-header__picture"
                    src={picture}
                    alt={picture}
                />
            );
        }

        const pageHeaderClasses = classNames({
            'authentication__page-header eds-text--center': !usesNewStyles,
            'authentication__page-header--new eds-text--left eds-l-mar-bot-10': usesNewStyles,
        });

        return (
            <div className={pageHeaderClasses}>
                {icon}

                <HeaderTitle
                    headerText={headerText}
                    subtitleText={subtitleText}
                    usesNewStyles={usesNewStyles}
                />
                <HeaderSubTitle
                    subtitleText={subtitleText}
                    usesNewStyles={usesNewStyles}
                />
            </div>
        );
    }
}
